import './ProductModal.scss';

import cn from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import postPublicPriceAndStock from '@/common/api/products/postPublicPriceAndStock';
import ButtonClose from '@/common/components/molecules/ButtonClose/ButtonClose';
import Product from '@/ebat/components/blocks/ScanSelfService/Product/Product';
import {
  ProductModalDefaultProps,
  ProductModalPropTypes,
} from '@/ebat/components/blocks/ScanSelfService/ProductModal/ProductModal.proptypes';
import { useScanSelfServiceContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceContext';

const AUTO_CLOSE_TIMEOUT = 15000;

const ProductModal = (props) => {
  const {
    brand,
    bundle_parents: bundleParents,
    categories,
    className,
    complementary_description: complementaryDescription,
    details,
    discountClasses,
    energetics,
    exclusivity,
    flags,
    image,
    isOpen,
    manufacturer_sku: manufacturerSku,
    name,
    price_and_stock: priceAndStock,
    range,
    sale_unit: saleUnit,
    sku,
    tax_rate: taxRate,
  } = props;

  const { uid } = useParams();
  const { clearProduct } = useScanSelfServiceContext();
  const timeoutIdRef = useRef(null);

  const handleClose = () => {
    clearProduct();
  };

  useEffect(() => {
    if (isOpen && !timeoutIdRef.current) {
      timeoutIdRef.current = setTimeout(() => {
        clearProduct();
        timeoutIdRef.current = null;
      }, AUTO_CLOSE_TIMEOUT);
    }
    return () => {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    };
  }, [isOpen, clearProduct]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={cn('self-service-product-container', className)}>
      <ButtonClose
        className="self-service-product__close"
        onClick={handleClose}
      />
      <Product
        apiPost={() =>
          postPublicPriceAndStock({
            queryKey: [`${uid}/price-and-stock`, sku],
          })
        }
        brand={brand}
        bundleParents={bundleParents}
        categories={categories}
        className="self-service-product"
        code={sku}
        complementaryDescription={complementaryDescription}
        customerPrice={priceAndStock?.price?.customer_price}
        details={details}
        discountClasses={discountClasses}
        discountPrice={priceAndStock?.price?.discount_price}
        energetics={energetics}
        exclusivity={exclusivity}
        flags={flags}
        image={image}
        invoiceUnit={priceAndStock?.invoice_unit}
        manufacturerSku={manufacturerSku}
        name={name}
        publicPrice={priceAndStock?.price?.public_price}
        range={range}
        saleUnit={saleUnit || priceAndStock?.sale_unit}
        salesPackaging={priceAndStock?.sales_packaging}
        sku={sku}
        taxRate={taxRate}
      />
    </div>
  );
};

ProductModal.defaultProps = {
  ...ProductModalDefaultProps,
};

ProductModal.propTypes = {
  ...ProductModalPropTypes,
};

export default ProductModal;
